import { ApiClient } from './client'
import {
  GET_SIGN_OUT,
  POST_SIGN_IN,
  POST_SIGN_IN_WITH_COGNITO,
  PUT_FACEBOOK_DISLINKING,
} from './endpoints'
import { ApiResponse } from './types'
import { SignInRequest, SignInWithCognitoRequest } from './types/auth'
import { CurrentCompany } from './types/currentCompany'
import { invalidateUser } from './user'

export const signIn = async ({
  email,
  password,
}: {
  email: string
  password: string
}) => {
  const body: SignInRequest = {
    company: { email, password },
  }
  const res = await ApiClient.post(POST_SIGN_IN, body)
  invalidateUser()
  return res
}
export const signOut = async () => {
  const res = await ApiClient.get(GET_SIGN_OUT)
  invalidateUser(true)
  return res
}
export const signInWithCognito = async (
  idToken: string,
): Promise<ApiResponse<CurrentCompany>> => {
  const body: SignInWithCognitoRequest = { id_token: idToken }
  const res = await ApiClient.post(POST_SIGN_IN_WITH_COGNITO, body)
  invalidateUser()
  return res
}

export const dislinkFacebook = async () => {
  const res = await ApiClient.put(PUT_FACEBOOK_DISLINKING)
  invalidateUser()
  return res
}
